import {
  ADDRESS_KEY,
  REFERRAL_ID_KEY,
  LOCAL_STORAGE_BANK_ID_TOKEN_KEY
} from '@/constants/local-storage-keys'
import { Address, Apartment } from '@/types'

export const updateReferralId = (referralId: number) => {
  if (referralId) {
    localStorage.setItem(REFERRAL_ID_KEY, `${referralId}`)
  } else {
    localStorage.removeItem(REFERRAL_ID_KEY)
  }
}

export const getReferralId = (): string | null => {
  return localStorage.getItem(REFERRAL_ID_KEY)
}

export const setAddress = (selectedAddress: Address & Apartment) => {
  localStorage.setItem(ADDRESS_KEY, JSON.stringify(selectedAddress))
}

export const getAddress = (): Address & Apartment | null => {
  return JSON.parse(localStorage.getItem(ADDRESS_KEY) || 'null')
}

export const setAuthenticationToken = (token: string) => {
  localStorage.setItem(LOCAL_STORAGE_BANK_ID_TOKEN_KEY, token)
}

export const getAuthenticationToken = (): string => {
  return localStorage.getItem(LOCAL_STORAGE_BANK_ID_TOKEN_KEY) || ''
}

export const removeAuthenticationToken = () => {
  localStorage.removeItem(LOCAL_STORAGE_BANK_ID_TOKEN_KEY)
}
